import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogExplainAccessComponent } from '@cigna/chcp/shared/ui';
import { DialogWamHelpFaqComponent } from '../dialog-wam-help-faq/dialog-wam-help-faq.component';
@Component({
  selector: 'cigna-wams-help-dropdown',
  templateUrl: './wams-help-dropdown.component.html',
  styleUrls: ['./wams-help-dropdown.component.scss'],
})
export class WamsHelpDropdownComponent {
  constructor(public dialog: MatDialog) {}

  openExplainAccessDialog() {
    this.dialog.open(DialogExplainAccessComponent, {
      autoFocus: false,
      width: '700px',
    });
  }

  openHelpFaqDialog() {
    this.dialog.open(DialogWamHelpFaqComponent, {
      autoFocus: false,
      width: '700px',
    });
  }
}
